import { CTA } from '@/features/CTA';
import ContentContainer from '@/features/shared/ContentContainer';
import { MuiContainer } from '@/features/shared/material-ui';
import { SpacingSizes } from '@/utils/constants';
import clsx from 'clsx';
import React, { memo } from 'react';
import useStyles from './CTA.styles';

const TechParnerCTA = ({ cta = { ctaContent: {} } }: any) => {
  const classes = useStyles({});
  const rootClasses = clsx(
    'tpd-standalone-cta',
    classes.root,
    `bg-color-${cta.themeBackgroundColor}`,
  );
  return (
    <ContentContainer
      topSpacing={cta.topPadding || SpacingSizes.small}
      bottomSpacing={SpacingSizes.small}
      topBackgroundColor={cta.topContainerBackgroundColor}
      bottomBackgroundColor="black"
    >
      <MuiContainer className="medium">
        <section>
          <CTA
            {...cta.ctaContent.content}
            theme={cta.textColor}
            backgroundColor={cta.themeBackgroundColor}
            className={rootClasses}
            displayBackgroundImage
          />
        </section>
      </MuiContainer>
    </ContentContainer>
  );
};

export default memo(TechParnerCTA);
